import React, { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiEditAlt } from "react-icons/bi";
import CreatePackages from "./addpackages";
import LinkPackagesAndTests from "./linkPackagesAndTests";
import UpdatePackagePriceModal from "./updatePackagePriceModal";
import { FiInfo } from "react-icons/fi";
import { Modal, Button } from "react-bootstrap";
import "./hm-theme.css";

function Packages() {
  const [packages, setPackages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isMapPackageAndTest, setIsMapPackageAndTest] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isUpdatePriceOpen, setIsUpdatePriceOpen] = useState(false);
  const [selectedPackageForPrice, setSelectedPackageForPrice] = useState(null);
  const [isPriceHistoryModalOpen, setIsPriceHistoryModalOpen] = useState(false);
  const [priceHistory, setPriceHistory] = useState([]);
  const [selectedPackageForHistory, setSelectedPackageForHistory] = useState(null);

  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;

  const getData = async () => {
    setLoader(true);
    try {
      const trans = await axios.get(`/api/package/getAllpackagesByRole`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await fetchTestNames(trans.data || []);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const fetchTestNames = async (pkgList) => {
    const packageTestNames = await Promise.all(
      pkgList.map(async (pkg) => {
        try {
          const response = await axios.get(`/api/packagetestmapping/packageid=${pkg.id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const testNames = response.data.map((item) => item.lab?.testname);
          return { ...pkg, testNames: Array.isArray(testNames) ? testNames : [] };
        } catch {
          return { ...pkg, testNames: [] };
        }
      })
    );
    setPackages(packageTestNames);
    setLoader(false);
  };

  const getCompanies = async () => {
    try {
      const response = await axios.get(`/api/companydetails/getCompanies`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanies(response.data || []);
    } catch (error) {
      handleError(error);
    }
  };

  const handleCreatePackage = () => {
    setSelectedPackage(null);
    setIsModalOpen(true);
  };

  const handleEditPackage = (pkg) => {
    setSelectedPackage(pkg);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const handleOpenMapPopup = (packageId) => {
    setSelectedPackage(packageId);
    setIsMapPackageAndTest(true);
  };

  const handleCloseMapPopup = () => {
    setSelectedPackage(null);
    setIsMapPackageAndTest(false);
    getData();
  };

  const handleOpenUpdatePrice = (pkg) => {
    setSelectedPackageForPrice(pkg.id);
    setIsUpdatePriceOpen(true);
  };

  const handleCloseUpdatePrice = () => {
    setSelectedPackageForPrice(null);
    setIsUpdatePriceOpen(false);
    getData();
  };

  const handlePriceHistory = (pkg) => {
    setSelectedPackageForHistory(pkg);
    setIsPriceHistoryModalOpen(true);
    fetchPriceHistory(pkg.id);
  };

  const fetchPriceHistory = async (packageId) => {
    setLoader(true);
    try {
      const response = await axios.get(`/api/labPackagePrice/packageId=${packageId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPriceHistory(response.data || []);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  useEffect(() => {
    getCompanies();
    getData();
  }, []);

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  const filteredPackages = packages.filter((pkg) => {
    const matchesCompany =
      selectedCompany === "" || (pkg.company && pkg.company.companyname === selectedCompany);
    const matchesSearchQuery = (pkg.packagename || "").toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCompany && matchesSearchQuery;
  });

  return (
    <div>
      <Dashboard />
      {loader && <div className="loading"></div>}

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">

          {/* Page Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">inventory_2</i>
                Test Packages
              </h2>
              <p className="hm-page-subtitle">Configure diagnostic health packages and link lab tests</p>
            </div>
            <button className="btn-hm-primary" onClick={handleCreatePackage}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>add</i>
              Add Test Package
            </button>
          </div>

          {/* Filter Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">filter_alt</i>
                Search & Filter Packages
              </h3>
            </div>
            <div className="hm-card-body">
              <div className="row g-3 align-items-end">
                <div className="col-md-6">
                  <label className="form-label small fw-semibold">Search Package</label>
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control ps-4"
                      placeholder="Search by package name..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <i className="material-icons position-absolute text-muted" style={{ left: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "1.1rem" }}>
                      search
                    </i>
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label small fw-semibold">Filter by Company</label>
                  <select
                    className="form-select"
                    value={selectedCompany}
                    onChange={(e) => setSelectedCompany(e.target.value)}
                  >
                    <option value="">All Companies</option>
                    {companies.map((comp) => (
                      <option key={comp.id} value={comp.companyname}>
                        {comp.companyname}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Table Card */}
          <div className="hm-card">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">folder_special</i>
                Health Packages List
              </h3>
              <span className="hm-badge hm-badge-primary">{filteredPackages.length} packages</span>
            </div>
            <div className="hm-card-body p-0">
              <div style={{ overflowX: "auto" }}>
                <table className="hm-table">
                  <thead>
                    <tr>
                      <th>Package Name</th>
                      <th>Company</th>
                      <th>Code</th>
                      <th>Description</th>
                      <th>Price</th>
                      <th>Linked Tests</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPackages.length === 0 ? (
                      <tr>
                        <td colSpan="7">
                          <div className="hm-empty-state">
                            <i className="material-icons">inventory</i>
                            <p>{loader ? "Loading packages..." : "No test packages found"}</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      filteredPackages.map((pkg) => (
                        <tr key={pkg.id}>
                          <td className="fw-semibold">{pkg.packagename}</td>
                          <td>{pkg.company?.companyname || "General"}</td>
                          <td>
                            <span className="hm-badge hm-badge-primary">{pkg.packageCode || "—"}</span>
                          </td>
                          <td className="small text-muted">{pkg.description || "—"}</td>
                          <td className="fw-bold">
                            ₹ {pkg.price || 0}
                            {pkg.price > 0 && (
                              <FiInfo
                                onClick={() => handlePriceHistory(pkg)}
                                style={{ cursor: "pointer", marginLeft: "6px", color: "#2cb6e9" }}
                                title="View Price History"
                              />
                            )}
                          </td>
                          <td>
                            {pkg.testNames.length > 0 ? (
                              <ul className="list-unstyled mb-0 small text-muted">
                                {pkg.testNames.map((testName, i) => (
                                  <li key={i}>• {testName}</li>
                                ))}
                              </ul>
                            ) : (
                              <span className="text-muted small">No Tests Linked</span>
                            )}
                          </td>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <button
                                className="btn btn-outline-primary btn-sm rounded-pill py-0 px-2"
                                style={{ fontSize: "0.78rem" }}
                                onClick={() => handleOpenMapPopup(pkg.id)}
                              >
                                Link Tests
                              </button>
                              <button
                                className="btn btn-outline-success btn-sm rounded-pill py-0 px-2"
                                style={{ fontSize: "0.78rem" }}
                                onClick={() => handleOpenUpdatePrice(pkg)}
                              >
                                Price
                              </button>
                              <button
                                className="btn btn-link text-dark p-0 border-0"
                                onClick={() => handleEditPackage(pkg)}
                                title="Edit Package"
                              >
                                <BiEditAlt size={18} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>

      {isModalOpen && (
        <CreatePackages
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          selectedPackage={selectedPackage}
        />
      )}
      {isMapPackageAndTest && (
        <LinkPackagesAndTests
          isOpen={isMapPackageAndTest}
          onRequestClose={handleCloseMapPopup}
          packageId={selectedPackage}
        />
      )}
      {isUpdatePriceOpen && (
        <UpdatePackagePriceModal
          isOpen={isUpdatePriceOpen}
          onRequestClose={handleCloseUpdatePrice}
          packageId={selectedPackageForPrice}
        />
      )}

      {/* Price History Modal */}
      <Modal show={isPriceHistoryModalOpen} onHide={() => setIsPriceHistoryModalOpen(false)} centered>
        <Modal.Header closeButton className="hm-card-header">
          <Modal.Title className="hm-card-title">
            Price History — {selectedPackageForHistory?.packagename}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          {priceHistory.length === 0 ? (
            <p className="text-muted text-center my-3">No price history available</p>
          ) : (
            <table className="hm-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {priceHistory.map((item, index) => (
                  <tr key={item.id || index}>
                    <td>{index + 1}</td>
                    <td>{item.date}</td>
                    <td className="fw-bold">₹ {item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setIsPriceHistoryModalOpen(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Packages;
